import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation/dist/additional-methods';
import 'jquery-validation-unobtrusive';

var settings = {
    errorClass: "is-invalid"
};
$.validator.setDefaults(settings);
$.validator.unobtrusive.options = settings;

// extend range validator method to treat checkboxes differently
var defaultRangeValidator = $.validator.methods.range;
$.validator.methods.range = function (value, element, param) {
    if (element.type === 'checkbox') {
        // if it's a checkbox return true if it is checked
        return element.checked;
    } else {
        // otherwise run the default validation function
        return defaultRangeValidator.call(this, value, element, param);
    }
}

var defaultAcceptValidator = $.validator.methods.accept;
$.validator.methods.accept = function (value, element, param) {
    // Skips validation if no mime type supplied
    if (typeof param === "string" && !/.+\/.+/.test(param)) {
        return true;
    }
    else {
        return defaultAcceptValidator.call(this, value, element, param);
    }
}

// Handle close modal dialogs
document.querySelectorAll('button[data-close-dialog]').forEach(function (e) {
    e.addEventListener('click', function () {
        this.closest('details').removeAttribute('open')
    });
});

// Set buttons to identity which button was clicked
// in order to show spinner for only 1 button and disable the rest.
document.querySelectorAll('button[type="submit"]').forEach(function (e) {
    e.addEventListener('click', function (e) {
        e.currentTarget.wasClicked = true;
    });
});

// Handle close alert messages
document.querySelectorAll('.js-flash-close').forEach(function (e) {
    e.addEventListener('click', function () {
        const element = this.closest('.flash');
        element.querySelectorAll('*').forEach(n => n.remove());
        element.remove();
    });
});


// On form submit finds all buttons of type submit and if the form is valid
// disables the button and sets it's content to be a "spinner".
document.querySelectorAll('form[data-spinner]').forEach(function (e) {
    e.addEventListener('submit', function (event) {
        if ($(event.target).valid()) {
            event.target.querySelectorAll('button[type="submit"]').forEach(function (btn) {
                var formactionValue = btn.getAttribute("formaction");
                var dataSpinnerText = btn.getAttribute("data-spinner-text");
                var wasClicked = btn.wasClicked == true;

                btn.disabled = true;  // disable all buttons

                // show spinner on the one was clicked
                if ((!formactionValue || dataSpinnerText) && wasClicked) {
                    btn.innerHTML = `<span class="spinner-border spinner-border-sm"
                                           role="status" aria-hidden="true"></span> ${dataSpinnerText ? dataSpinnerText : "Submitting..."}`;
                }
            })
        }
    });
});
